import React from 'react';
import { StarIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy text-white py-10 px-4" data-id="element-57">
      <div className="max-w-4xl mx-auto" data-id="element-58">
        <div className="flex flex-col items-center gap-4" data-id="element-59">
          <div className="flex items-center gap-2" data-id="element-60">
            <StarIcon className="w-5 h-5 text-gold" data-id="element-61" />
            <span className="font-serif text-xl" data-id="element-62">Hogar Bienestar</span>
          </div>
          <p className="text-white/40 text-sm" data-id="element-63">
            © 2026 Hogar Bienestar. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}